module.exports = __webpack_public_path__ + "static/media/icon_reservation_active.4130ced4.svg";